import { Component, OnInit } from '@angular/core';
import { Paginacao } from '../../comum/modelos/paginacao';
import { RotinaService } from '../rotina.service';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { RotinaCliente } from '../../comum/modelos/rotina-cliente';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-listar-rotinas-cliente',
  templateUrl: './listar-rotinas-cliente.component.html',
  styleUrls: ['./listar-rotinas-cliente.component.css']
})
export class ListarRotinasClienteComponent implements OnInit {

  filtroPesquisaNomeRotina: string;

  rotinasCliente: RotinaCliente[];

  paginacao: Paginacao;

  evento: Evento;

  public loading = false;

  selecionados: boolean;
  statusCode: number;

  constructor(private _rotinaService: RotinaService,
    private _comumService: ComumService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private _cookieService: CookieService,
    public _authService: AuthService) {
    this.paginacao = new Paginacao();
    this.paginacao.itens = 5;
    this.paginacao.page = 1;

    this.evento = this._comumService.evento;

    this.rotinasCliente = new Array<RotinaCliente>();

    if (this.evento !== undefined) {
      setTimeout(() => {
        this._comumService.cleanEvent();
      }, 3000);
    }

  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.loading = true;

    const self = this;
    const idCliente = parseInt(this._cookieService.get('idCliente'), 10);
    /* const rc = this._rotinaService.obterRotinasClienteHttp(idCliente);
     const r = this._rotinaService.obterRotinasHttp();

     forkJoin(r, rc)
       .subscribe(([rotinas, rotinasCliente]) => {
         for (const rotina of rotinas) {
           const novaRotinaCliente = new RotinaCliente();
           novaRotinaCliente.idRotina = rotina.idRotina;
           novaRotinaCliente.idCliente = idCliente;
           novaRotinaCliente.descricaoRotina = rotina.descricaoRotina;
           novaRotinaCliente.criticidadeRotina = rotina.criticidadeRotina;

           for (const rotinaCliente of rotinasCliente) {
             if (rotinaCliente.idRotina === rotina.idRotina) {
               novaRotinaCliente.idRotinaCliente = rotinaCliente.idRotinaCliente;
               novaRotinaCliente.selecionado = true;
               break;
             }
           }
           self.rotinasCliente.push(novaRotinaCliente);
         }
         self.loading = false;
       });*/

    this._rotinaService.obterRotinasClienteHttp(idCliente)
      .subscribe(rotinasCliente => {
        self.rotinasCliente = rotinasCliente;
        self.loading = false;
      });
  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaNomeRotina = filtro.value;
  }

  selecionar(rotinaCliente: RotinaCliente): void {
    rotinaCliente.selecionado = !rotinaCliente.selecionado;
    rotinaCliente.alterado = true;
  }

  selecionarTodos(): void {
    this.selecionados = !this.selecionados;
    this.rotinasCliente.forEach(rotinaCliente => {
      rotinaCliente.selecionado = this.selecionados;
      rotinaCliente.alterado = true;
    });
  }

  onSubmit(): void {
    this.loading = true;
    const rotinasClienteInsert = new Array<RotinaCliente>();
    const rotinasClienteRemove = new Array<RotinaCliente>();
    this.rotinasCliente.forEach(rotinaCliente => {
      if (!rotinaCliente.selecionado && rotinaCliente.idRotinaCliente !== undefined && rotinaCliente.alterado) {
        rotinasClienteRemove.push(rotinaCliente);
      } else if (rotinaCliente.selecionado && rotinaCliente.idRotinaCliente === undefined
        && rotinaCliente.alterado) {
        rotinasClienteInsert.push(rotinaCliente);
      }
    });
    if (rotinasClienteRemove.length > 0) {
      this._rotinaService.removerRotinasClienteHttp(rotinasClienteRemove)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          this.router.navigate(['rotinas']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
    if (rotinasClienteInsert.length > 0) {
      this._rotinaService.cadastrarRotinasClienteHttp(rotinasClienteInsert)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          this.router.navigate(['rotinas']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
    this.loading = false;
  }

  removerRotinaCliente(rotinaCliente: RotinaCliente): void {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir o checklist?',
      accept: () => {
        this.loading = true;
        this._rotinaService.removerRotinaClienteHttp(rotinaCliente.idRotinaCliente).subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.deletar = true;
          this.removerRotinaClienteFromList(this.rotinasCliente, rotinaCliente);
          setTimeout(() => {
            this.evento.limparEventos();
          }, 3000);
        }, errorCode => {
          this.statusCode = errorCode;
          this._comumService.evento.deletar = true;
          this._comumService.evento.error = true;
          this.loading = false;
          setTimeout(() => {
            this.evento.limparEventos();
          }, 3000);
        });
      },
      reject: () => {
      }
    });
  }

  removerRotinaClienteFromList(rotinasCliente: RotinaCliente[], rotinaCliente: RotinaCliente): void {
    const index = this.obterIdRotinaCliente(rotinasCliente, rotinaCliente);
    rotinasCliente.splice(index, 1);
  }

  obterIdRotinaCliente(rotinasCliente: RotinaCliente[], rotinaCliente: RotinaCliente): number {
    return rotinasCliente.indexOf(rotinaCliente);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/rotina/listar-rotinas-cliente/listar-rotinas-cliente.component.ts